import { Button, Grid, Typography, TextField, Box, Hidden, FormControl, InputLabel, Select, Tooltip } from "@mui/material";
import { Search as IconSearch, PersonAdd as IconPersonAdd, AssignmentInd as IconFicha } from "@mui/icons-material";
import { puedeAccederFichaIngreso } from "../../services/permisoService";
import { obtenerUsuario } from "../../services/authService";
import * as participanteService from "../../services/participanteService";
import * as filialService from "../../services/filialService";
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from "react";
import moment from "moment";
import { Link, useNavigate } from "react-router-dom";
import { setValue } from '../../redux/memberSearchSlice';
import DataGridBase from "../../components/common/DataGridBase"
import { useMantenimiento } from "../../hooks/useMantenimiento";

const Index = () => {
    const { isReadOnly } = useMantenimiento("participante");
    const idFilialUsuario = useSelector((state) => state.seguridad?.idFilial) || 0;
    const filters = useSelector((state) => state.memberSearch.filters);
    const personList = useSelector((state) => state.person.personList);
    const [cargando, setCargando] = useState(true);
    const [results, setResults] = useState([]);
    const [listFiliales, setListFiliales] = useState([]);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        const filialInicial = idFilialUsuario > 0 ? idFilialUsuario : 0;
        if (idFilialUsuario > 0) {
            dispatch(setValue({ name: "idFilial", value: idFilialUsuario }));
        }

        filialService.getFilialesList().then((data) => {
            setListFiliales(filialService.soloFilialDelUsuario(data, idFilialUsuario));
        }).catch(() => {});

        fetchResults({ idFilial: filialInicial });
    }, [idFilialUsuario, dispatch])

    const fetchResults = async (overrideFilters = {}) => {
        setCargando(true);

        const currentFilters = { ...filters, ...overrideFilters };
        const filialFiltro = currentFilters.idFilial !== undefined
            ? currentFilters.idFilial
            : (idFilialUsuario > 0 ? idFilialUsuario : 0);

        await participanteService.getsParticipantesResumenViewByMemberOrRelative(
            currentFilters.member,
            currentFilters.relative,
            filialFiltro
        )
            .then((data) => {
                setResults(data || []);
                setCargando(false);
            })
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err)
            });
    }

    const rolesUsuario = useSelector((state) => state.seguridad?.roles) || [];
    const usuarioActual = obtenerUsuario();
    const tienePermisoFicha = puedeAccederFichaIngreso(usuarioActual, rolesUsuario);

    const baseColumns = [
        { field: 'id', headerName: 'ID', width: 50, minWidth: 45, sortable: true, headerAlign: 'center', align: 'center',
            renderCell: (p) => <span style={{ fontSize: '0.75rem', color: '#666', fontFamily: 'monospace' }}>{p.value != null ? p.value : p.row.id}</span> },
        { field: 'filial', headerName: 'Filial', width: 75, minWidth: 65, sortable: true, headerAlign: 'center', align: 'center',
            renderCell: (p) => p.row.codigoFilial || p.row.filial || '' },
        { field: 'participante', headerName: 'Nombre Participante', width: 220, sortable: false, headerAlign: 'center'
            , renderCell: (cellValues) => {
                return <Link to={'/member/edit/' + cellValues.row.id} style={{ color: 'inherit' }}>{cellValues.row.participante}</Link>;
            }
        },
        { field: 'fechaIngreso', headerName: 'Fecha Ingreso', width: 120, minWidth: 105, sortable: true, headerAlign: 'center', align: 'center',
            valueGetter: (value, row) => value || row?.fechaIngreso || row?.FechaIngreso || '',
            renderCell: (cellValues) => {
                const val = cellValues.value || cellValues.row?.fechaIngreso || cellValues.row?.FechaIngreso;
                return (val && moment(val).isValid()) ? moment(val).format('DD/MM/YYYY') : '';
            }
        },
        { field: 'padre', headerName: 'Padre', width: 200, sortable: false, headerAlign: 'center' },
        { field: 'madre', headerName: 'Madre', width: 200, sortable: false, headerAlign: 'center' },
        { field: 'estado', headerName: 'Estado', width: 75, sortable: false, headerAlign: 'center', align: 'center' },
    ];

    const columns = tienePermisoFicha ? [
        ...baseColumns,
        { field: 'ficha', headerName: 'Ficha', width: 65, sortable: false, headerAlign: 'center', align: 'center',
            renderCell: (p) => (
                <Tooltip title="Ver / Imprimir Ficha de Matrícula">
                    <Link to={`/reporte/ficha-participante?idParticipante=${p.row.id}`} style={{ color: '#1976d2', display: 'flex', alignItems: 'center' }}>
                        <IconFicha fontSize="small" />
                    </Link>
                </Tooltip>
            )
        },
    ] : baseColumns;

    return (
        <div>
            <Grid container>
                <Grid item>
                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                        Participantes
                    </Typography>
                </Grid>
                <Grid container spacing={1} padding={"12px 0px 0px 0px"}>
                    <Grid item xs={12} sm={12}>
                        <Grid container item xs={12} sm={12} spacing={1}>
                            <Grid item xs={12} sm={2.5} md={2}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="input-filialfiltro" shrink>Filial</InputLabel>
                                    <Select
                                        native
                                        label="Filial"
                                        value={filters.idFilial || (idFilialUsuario > 0 ? idFilialUsuario : 0)}
                                        disabled={idFilialUsuario > 0}
                                        onChange={(event) => {
                                            const val = parseInt(event.target.value) || 0;
                                            dispatch(setValue({ name: "idFilial", value: val }));
                                            fetchResults({ idFilial: val });
                                        }}
                                        onKeyDown={(event) => {
                                            if (event.key === "Enter") {
                                                event.preventDefault();
                                                fetchResults();
                                            }
                                        }}
                                        inputProps={{ name: 'idFilial', id: 'input-filialfiltro' }}
                                        size="small"
                                    >
                                        {idFilialUsuario <= 0 && <option key={0} value={0}>{"(Todas las filiales)"}</option>}
                                        {listFiliales.map((row) => (
                                            <option key={row.id} value={row.id}>{row.descripcion || row.nombre}</option>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4} md={4.5}>
                                <TextField
                                    name="member"
                                    label="Nombre Participante"
                                    value={filters.member}
                                    fullWidth
                                    onChange={(event) => {
                                        dispatch(setValue({name: "member", value: event.target.value}))
                                    }}
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            event.preventDefault();
                                            fetchResults();
                                        }
                                    }}
                                    size="small"
                                />
                            </Grid>
                            <Grid item xs={8} sm={4} md={4}>
                                <TextField
                                    name="relative"
                                    label="Nombre Familiar"
                                    value={filters.relative}
                                    fullWidth
                                    onChange={(event) => {
                                        dispatch(setValue({name: "relative", value: event.target.value}))
                                    }}
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            event.preventDefault();
                                            fetchResults();
                                        }
                                    }}
                                    size="small"
                                />
                            </Grid>
                            <Grid item xs={4} sm={1.5} md={1.5} display={"flex"} alignItems={"center"}>
                                <Button variant="outlined" fullWidth size="medium" onClick={() => { fetchResults() }}>
                                    <IconSearch />
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr' }}>
                            <DataGridBase
                                rows={results}
                                columns={columns}
                                loading={cargando}
                                disabled={isReadOnly}
                                toolbarButtons={[
                                    {
                                        text: "Nuevo",
                                        icon: <IconPersonAdd />,
                                        disabled: isReadOnly,
                                        onClick: () => navigate("/member/edit/0")
                                    }
                                ]}
                            />
                        </Box>
                    </Grid>
                </Grid>
            </Grid>
        </div>
    )
}
export default Index
